import React from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import useFetchContentfulData from '../../hooks/useFetchContentfulData';
import { fieldIotProductSelected } from '../../utils/constant';
import SummaryTracker from '../summaryTracker';

const SummaryTrackerSummary = ({ orderData }) => {
  const {
    ratePlan,
    addons,
    additionalServices,
    hardware,
    vehicleInfo,
    installServices,
    orderNow,
    geotabBundles
  } = orderData;
  const {
    contentfulValues: {
      valueGeotab,
      valueFleetcomplete,
      valueRaven,
      valueNorthStarSystems,
      valueFillipFleet,
      valueGeoforce
    }
  } = useLocalizedStringsContext();

  const valueProductSelected = _.get(orderData, fieldIotProductSelected, '');
  const getIotOrderDetilsKey = () => {
    let orderDetailsKey;
    switch (valueProductSelected) {
      case valueGeotab:
        orderDetailsKey = 'ioTGeoTabOrderDetails';
        break;
      case valueFleetcomplete:
        orderDetailsKey = 'ioTFleetCompleteOrderDetails';
        break;
      case valueRaven:
        orderDetailsKey = 'ioTRavenOrderDetails';
        break;
      case valueNorthStarSystems:
        orderDetailsKey = 'ioTNorthStarSystemsOrderDetails';
        break;
      case valueFillipFleet:
        orderDetailsKey = 'ioTNorthStarSystemsFarmNRanchOrderDetails';
        break;
      case valueGeoforce:
        orderDetailsKey = 'ioTGeoforceOrderDetails';
        break;
      default:
        orderDetailsKey = 'ioTFleetCompleteOrderDetails';
        break;
    }
    return orderDetailsKey;
  };
  const { data: contentfulData } =
    orderData && useFetchContentfulData(getIotOrderDetilsKey());

  let ratePlanListUpdated;
  if (contentfulData) {
    ratePlanListUpdated =
      valueProductSelected === valueFillipFleet
        ? contentfulData.rateplanListFillipFleet
        : contentfulData.rateplanList;
  }

  return (
    <>
      {orderData && contentfulData && (
        <SummaryTracker
          productSelected={valueProductSelected}
          rateplanList={ratePlanListUpdated}
          hasAdditonalServices={_.get(
            contentfulData,
            'additionalServicesList',
            ''
          )}
          ratePlans={ratePlan}
          addons={addons}
          additionalServices={additionalServices}
          hardware={hardware}
          vehicleInfo={vehicleInfo}
          installServices={installServices}
          orderNow={orderNow}
          geotabBundles={geotabBundles}
        />
      )}
    </>
  );
};

SummaryTrackerSummary.propTypes = {
  orderData: PropTypes.shape({
    ratePlan: PropTypes.object,
    addons: PropTypes.object,
    additionalServices: PropTypes.object,
    hardware: PropTypes.object,
    installServices: PropTypes.object,
    orderNow: PropTypes.object,
    geotabBundles: PropTypes.object,
    vehicleInfo: PropTypes.arrayOf(PropTypes.object)
  }).isRequired
};

export default SummaryTrackerSummary;
